import React from 'react'

import Hide from 'hidden-styled'
import styled from 'styled-components'
import {
	Absolute,
	BackgroundImage,
	Box,
	Button,
	Container,
	Flex,
	Divider,
	Heading,
	Measure,
	Relative,
	Text,
} from 'rebass'

import SvgLogo from '../utils/logo.js'
import Image from '../images/background-image.jpg'

class ImageHeader extends React.Component {
	render() {
		return (
			<section>
				<Relative>
					<Flex
						bg="#000000"
						alignItems={['center', 'center', 'center']}
						justifyContent={['flex-start', 'center', 'center']}
					>
						<BackgroundImage
							mt={[6, 0, 0]}
							width={1}
							ratio={1 / 2}
							bg="black"
							backgroundPosition="center"
							backgroundSize="cover"
							src={Image}
						/>
						<Absolute>
							<Container>
								<Flex
									flexWrap="nowrap"
									flexDirection="column"
									alignItems="flex-start"
									justifyContent="flex-start"
								>
									<Box pr={[0, 5, 8]} pl={[4, 0, 0]}>
										<Box width={[5 / 8, 3 / 6, 4 / 6]}>
											<SvgLogo />
										</Box>
										<Box
											width={[4 / 5, 3 / 5, 6 / 7]}
											pt={1}
										>
											<Divider />
										</Box>
										<Measure
											pt={2}
											color={'white'}
											fontSize={[1, 2, 3]}
											maxWidth="28em"
											children="Development of web and mobile apps."
										/>
										<Measure
											mt={1}
											color="white"
											fontSize={[1, 2, 3]}
											maxWidth="28em"
											children="Team augmentation. Agile software engineering."
										/>
										<Measure
											mt={1}
											color="white"
											fontSize={[1, 2, 3]}
											maxWidth="28em"
											children="High quality results that adapt to your needs."
										/>
										<Hide xs sm md lg>
												<Button
													borderRadius={20}
													mt={4}
													py={2}
													px={4}
													fontSize={[2, 2, 2]}
													bg="#ffffff"
													color="#111111"
													children="Let's work together"
												/>
										</Hide>
									</Box>
								</Flex>
							</Container>
						</Absolute>
					</Flex>
				</Relative>
			</section>
		)
	}
}

export default ImageHeader



// WEBPACK FOOTER //
// ./src/components/header.js